import { render } from "./Penitenzieria.vue?vue&type=template&id=1b5820a4"
import script from "./Penitenzieria.vue?vue&type=script&lang=js"
export * from "./Penitenzieria.vue?vue&type=script&lang=js"

import "./Penitenzieria.vue?vue&type=style&index=0&id=1b5820a4&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__